/**
 * Find the greatest common divisor between two numbers
 */
export default function gcd(a: number, b: number): number {
  if (a === 0) return b;
  return gcd(b % a, a);
}
